import { connect } from 'react-redux';
import { add, update, remove, search } from '../../modules/inventory/fuelSubContract';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => ({
	fuelSubContractMap: state.maps.fuelSubContract || {},
	bulkCustomers: state.maps.bulkCustomer ? Object.values(state.maps.bulkCustomer) : [],
});

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			addFuelSubContract: add,
			updateFuelSubContract: update,
			removeFuelSubContract: remove,
			searchFuelSubContracts: search,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
